import FoodTypeListTable from './Components/FoodTypeListTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddFoodType from '../AddFoodType/AddFoodType';
import { useRoleVerify } from 'Common/RoleVerify';
import { useState } from 'react';

const FoodTypeList = () => {
    const [refetch, setRefetch] = useState(false)
    const canShowAction = useRoleVerify("", ["can_create"]);
    return (
        <>
            {canShowAction &&
                <AddFoodType
                    setRefetch={setRefetch}
                    refetch={refetch}
                />
            }

            <PageBody
                card={true}
                headerchildren={
                    <HeadingOne>Food Categories List</HeadingOne>
                }>

                {/* Table section */}
                <div className="col-12">
                    <FoodTypeListTable refetch={refetch} />
                </div>
            </PageBody>

        </>
    );
};

export default FoodTypeList;
